import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoManagementSue} from "./models/DtoManagementSue";
import {DtoManagementSueFilter} from "./models/DtoManagementSueFilter";

@Injectable()
export class MarketingInfoService {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'management'
    }

    public getSueInfo = (filter: DtoManagementSueFilter): Observable<DtoManagementSue> => {
        return this.http.post<DtoManagementSue>(`${this.apiUrl}/sueinfo/`, filter);
    };
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/marketing/marketing-info/marketing-info.service.ts